import { useMemo } from "react"

import { Box, Grid, Skeleton } from "@mui/material"
import { useFormContext, useWatch } from "react-hook-form"

import { CardTitle, ControlledTextField } from "components/common"
import { CreateAndUpdateVehicleDtoInput, useGetSpecialServicesQuery } from "generated/graphql"

import SpecialServiceItem, { SpecialServiceType } from "./SpecialServiceItem"

const SpecialServices = () => {
  const { loading: loadingSPecialServices, data: specialServicesData } = useGetSpecialServicesQuery()

  const { setValue, control } = useFormContext<CreateAndUpdateVehicleDtoInput>()
  const specialServiceIds: Array<number> = useWatch({ control, name: 'specialServiceIds', defaultValue: [] })

  const specialServiceItems: Array<SpecialServiceType> = useMemo(() => {
    if (!specialServicesData) return []

    return specialServicesData.specialServices.map((service) => ({
      id: service.id,
      name: service.name,
      active: specialServiceIds.includes(Number(service.id))
    }))
  }, [specialServicesData, specialServiceIds])

  const onAddClick = (id: number) => {
    const newSpecialServiceIds = [...specialServiceIds, id]
    setValue('specialServiceIds', newSpecialServiceIds, { shouldDirty: true })
  }

  const onRemoveClick = (id: number) => {
    const newSpecialServiceIds = specialServiceIds.filter((serviceId) => serviceId !== id)
    setValue('specialServiceIds', newSpecialServiceIds, { shouldDirty: true })
  }

  return <>
    <CardTitle >
      Special Services
    </CardTitle>

    {loadingSPecialServices ? (
      <Skeleton variant="rectangular" height={200} />
    ) : (
      <Grid container spacing={3}>
        <Box hidden>
          <ControlledTextField
            name='specialServiceIds'
            control={control}
            label='Special Service Ids'
            defaultValue={[]}
          />
        </Box>
        {specialServiceItems.map((service) => (
          <SpecialServiceItem
            key={service.name}
            value={service}
            onAddClick={onAddClick}
            onRemoveClick={onRemoveClick}
          />
        ))}
      </Grid>
    )}
  </>
}

export default SpecialServices
